export default "__VITE_ASSET__DnD5nfxw__"